<div class="img-wrapper">  
  <div class="front">
    <a [routerLink]="['/home/left-sidebar/product', product.sku]"><img  class="img-fluid" alt=""></a>
  </div>  
  <div class="cart-info cart-wrap" *ngIf="!productsService?.catalogMode">
    <a [routerLink]="" [attr.data-target]="'#addtocart'+product.sku" data-toggle="modal" (click)="addToCart(product)" data-placement="left" title="Add to cart">
       <i class="ti-shopping-cart" ></i>
    </a>
    <a [routerLink]="" (click)="addToWishlist(product)" title="Add to Wishlist">
       <i class="ti-heart" aria-hidden="true"></i>
    </a>
    <a [routerLink]="" [attr.data-target]="'#quick-view'+product.sku" data-toggle="modal" title="Quick View">
       <i class="ti-search" aria-hidden="true"></i>
    </a>
    <a [routerLink]="['/home/compare']" (click)="addToCompare(product)" title="Compare">
       <i class="ti-reload" aria-hidden="true"></i>
    </a>
  </div>
</div>
<div class="product-detail">
  <div>
    <bar-rating [rate]="5" [readOnly]="true"></bar-rating>
    <a [routerLink]="['/home/left-sidebar/product', product.sku]"><h6>{{product.name}}</h6></a>
    <h4 *ngIf="!productsService?.catalogMode">{{product.unitPrice | currency:productsService?.currency:'symbol'}} 
      <del><span class="money">{{product.unitPrice | currency:productsService?.currency:'symbol'}}</span></del> 
    </h4>    
  </div>
</div>
